import React from "react";
import { connect } from "react-redux";
import { CenterLayout } from "../../Layout";
import BusinessCategory from "../../components/Onboard/BusinessCategory";

class OnboardInitialScreen extends React.Component {
  state = {
    isLoading: false,
  };

  render() {
    return (
      <CenterLayout>
        <BusinessCategory />
      </CenterLayout>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(OnboardInitialScreen);
